import { Box, Button, IconButton, Modal, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Iconify from '../Iconify';
import { Close } from '@mui/icons-material';
import useLocales from 'src/hooks/useLocales';
import { LoadingButton } from '@mui/lab';
import { useMutation, useQueryClient } from 'react-query';
import { Examen } from 'src/classes/Examen';
import { useSnackbar } from 'notistack';

function EditDescriptionModal({ open, handleClose, item }) {
    const updateExamInVetCase = useMutation(({ id, data }) => Examen.updateExamInCase(id, data))
    const [description, setDescription] = useState('')
    const { enqueueSnackbar } = useSnackbar();
    const query = useQueryClient()
    useEffect(() => {
        if (!item) return
        setDescription(item?.description)
    }, [item])

    const { translate } = useLocales()

    const onSave = () => {
        updateExamInVetCase.mutateAsync({ id: item.relation_id,data:{ description} })
            .then(() => {
                enqueueSnackbar(translate('snackbar.updateSuccess'), {
                    variant: 'success'
                })
                query.refetchQueries(['vet_case_exams'])
            }).catch(err => {
                enqueueSnackbar(translate('general.error'), {
                    variant: 'error'
                })
            }).finally(() => {
                handleClose()
                query.refetchQueries(['vet_case_exams'])

            })

    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box sx={style}>
                {/* Header */}
                <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                    <Box display='flex' gap={1} alignItems='center'>
                        <Iconify color='primary' icon='mage:edit' width={21} height={21} />
                        <Typography fontWeight={600} variant='h6'>{translate('team.edit')}</Typography>
                    </Box>
                    <IconButton onClick={handleClose}>
                        <Close fontSize='small' />
                    </IconButton>
                </Box>

                <TextField value={description} onChange={e => setDescription(e.target.value)} multiline rows={2} fullWidth label={translate("description")}></TextField>
                <Box width='100%' marginTop={2} display='flex' justifyContent='end' alignItems='center' gap={2}>
                    <Button disabled={updateExamInVetCase.isLoading} onClick={handleClose} variant='outlined'>{translate('nav.cancel')}</Button>
                    <LoadingButton onClick={onSave} type='submit' loading={updateExamInVetCase.isLoading} color='primary' variant='contained'>{translate('gridOptions.update')}</LoadingButton>
                </Box>
            </Box>
        </Modal>
    )
}

export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 1
};

export default EditDescriptionModal